import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "../../../common/consts/colors";

export default function MapMarkerIcon({
  color = "offWhite",
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M10 6.66669C9.07953 6.66669 8.33334 7.41288 8.33334 8.33335C8.33334 9.25383 9.07953 10 10 10C10.9205 10 11.6667 9.25383 11.6667 8.33335C11.6667 7.41288 10.9205 6.66669 10 6.66669Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8524 17.8185C10.7706 17.904 10.7059 17.9706 10.6612 18.0162L10.6096 18.0687L10.5958 18.0827L10.5908 18.0877C10.5908 18.0877 10.5908 18.0877 10.5847 18.0817L10.5902 18.0883C10.4339 18.2452 10.2215 18.3334 10 18.3334C9.7785 18.3334 9.56589 18.2449 9.40953 18.0881C9.40953 18.0881 9.40954 18.0881 9.41572 18.0819L9.40953 18.0881L9.40421 18.0827L9.39036 18.0687L9.33877 18.0162C9.29511 17.9725 9.23361 17.9083 9.15552 17.8268L9.14757 17.8185C8.98385 17.6476 8.75116 17.4009 8.47242 17.0948C7.9158 16.4836 7.17155 15.6313 6.42522 14.6705C5.68127 13.7128 4.92176 12.63 4.34455 11.559C3.7793 10.5102 3.33334 9.37324 3.33334 8.33335C3.33334 4.55082 6.32674 1.66669 10 1.66669C13.6733 1.66669 16.6667 4.55082 16.6667 8.33335C16.6667 9.37324 16.2207 10.5102 15.6555 11.559C15.0782 12.63 14.3187 13.7128 13.5748 14.6705C12.8285 15.6313 12.0842 16.4836 11.5276 17.0948C11.2488 17.4009 11.0162 17.6476 10.8524 17.8185ZM6.66667 8.33335C6.66667 6.4924 8.15905 5.00002 10 5.00002C11.841 5.00002 13.3333 6.4924 13.3333 8.33335C13.3333 10.1743 11.841 11.6667 10 11.6667C8.15905 11.6667 6.66667 10.1743 6.66667 8.33335Z"
        fill={COLORS[color]}
      />
    </svg>
  );
}
